module.exports = __webpack_public_path__ + "static/img/1.ba3ca27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg/1.png
// module id = 121
// module chunks = 2